<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative"
  style="min-height: 23em;">
  <div
    class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative">
    <div class="o-stack__cell">
      <h5>Testing</h5>
    </div>
  </div>
  <div class="analytics-portlet-content">
    <div style="width: 100%; height: 100%;">
      <div id="scatterChart" #scatterChartElement></div>
    </div>
  </div>
</div>